import utils from "../../../utils/utils.js";

export default {
  async fetchEngagementAnswerGalleries(context, payload) {
    const pageNumber = payload.pageNumber;
    const pageSize = payload.pageSize;
    const sortColumn = payload.sortColumn;
    const sortDirection = payload.sortDirection;
    const searchText = payload.searchText;

    const responseData = await utils.utility.fetch(
      `api/Setting/GetEngagementAnswerGalleries?pageNumber=${pageNumber}&pageSize=${pageSize}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&searchText=${searchText}`,
      "GET",
      null,
      null
    );
    context.commit("setEngagementAnswerGalleries", responseData.data);
  },

  async deleteEngagementAnswerGallery(context, payload) {
    let postData = { id: payload.id };
    await utils.utility.fetch(
      `api/Setting/DeleteEngagementAnswerGallery`,
      "POST",
      null,
      postData
    );
  },
};
